import { defineStore } from 'pinia'
import { navigateTo } from '@/utils/navigator'

export const useLoginStore = defineStore('login', {
  state: () => ({
    loginType: 'login',
    showLoginPopup: false,
    redirectUrl: '',
    loginCallback: null as (() => void) | null,
  }),
  actions: {
    // 显示登录弹窗
    showLogin(redirectUrl = '', callback?: () => void, forceRefresh = false) {
      // 如果登录弹窗已经显示且不需要强制刷新，只更新参数
      if (this.showLoginPopup && !forceRefresh) {
        this.redirectUrl = redirectUrl
        this.loginCallback = callback || null
        return
      }

      // 如果需要强制刷新且弹窗已显示，先隐藏再显示
      if (this.showLoginPopup && forceRefresh) {
        this.showLoginPopup = false
        // 使用 requestAnimationFrame 确保 DOM 更新完成后再显示
        requestAnimationFrame(() => {
          this.showLoginPopup = true
          this.redirectUrl = redirectUrl
          this.loginCallback = callback || null
        })
        return
      }

      // 如果登录弹窗未显示，则直接显示
      this.showLoginPopup = true
      this.redirectUrl = redirectUrl
      this.loginCallback = callback || null
    },
    // 关闭登录弹窗
    hideLogin() {
      this.showLoginPopup = false
      this.redirectUrl = ''
      this.loginCallback = null
    },
    // 登录成功后的处理
    handleLoginSuccess() {
      // 执行回调
      if (this.loginCallback) {
        this.loginCallback()
      }
      // 处理重定向
      if (this.redirectUrl) {
        navigateTo({
          url: this.redirectUrl,
        })
      }
      this.hideLogin()
    },
  },
})
